import React from 'react';
import Report from './ReportComponent';
import { connect } from 'react-redux';

export function thousandFormat(ws, col, content) {
  if (!content?.length) return;
  let range = content?.length;
  for (let i = 2; i < range + 2; i++) {
    ws[`${col}${i}`].z = '#,##0';
  }
}

const BankStaffReport = ({ reports }) => {
  return (
    <div className='bank-staff-report container'>
      {reports?.map((r) => (
        <Report key={r.name} {...r} />
      ))}
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const bank = state?.lookup?.bank;
  const reports = state?.lookup?.reports?.map((e) => ({
    title: e.title,
    name: e.code,
    filter: e.filter,
    formatter: e?.columns
      .map((e, i) => {
        if (!e.type) return null;
        return (ws, content) => {
          let col = i > 25 ? 'A' + String.fromCharCode(65 + i - 26) : String.fromCharCode(65 + i);
          console.log(col);
          return thousandFormat(ws, col, content);
        };
      })
      .filter((e) => e),
  }));
  return { bank, reports };
};

export default connect(mapStateToProps)(BankStaffReport);
